import { getCurrentBrandId } from "@zendesk/knowledge-context";

export const getUserSegmentsUrl = () =>
  `/knowledge/user_segments?brand_id=${getCurrentBrandId()}`;

export const getPermissionsUrl = () =>
  `/knowledge/permissions?brand_id=${getCurrentBrandId()}`;



// WEBPACK FOOTER //
// ./src/utils/urls.js